module.exports = __webpack_public_path__ + "img/Moon and Stairs Mystical Logo Template (9).2d90fe84.png";